// src/pages/admin/{Notice1FormForm.js
import React from "react";
import FormWrapper from "../../forms/shared/FormWrapper";
import NoticeofCapitalReduction from "../../forms/anounce/Notice-of-Capital-Reduction/NoticeofCapitalReduction";

function NoticeofCapitalReductionPage() {
  return (
    <FormWrapper
      title="เลิกบริษัทประกาศเลิกขั้นตอนที่4-เสร็จชำระบัญชี"
      FormComponent={NoticeofCapitalReduction}
      formKey="Notice-of-Capital-Reduction" // key ไว้แยกชื่อไฟล์รูป/เก็บ localStorage ถ้ามี
    />
  );
}

export default NoticeofCapitalReductionPage;
